import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Dialog, Link, Loading, Table } from 'tdesign-react';
import JSONPretty from 'react-json-pretty';
import styled from 'styled-components';
import { fetchLedgerMeta } from '@/slices/topicSlice';
import ModalHeader from '@/components/Header/Modal';
import Descriptions from '@/components/Descriptions';

const columns = [
  {
    colKey: 'key',
    title: '编号',
    width: 100,
  },
  {
    colKey: 'value',
    title: '位置',
  },
];

function LedgerModal({ commonProps, detail, fetchLedgerMeta, meta, loading }) {
  const [visible, setVisible] = useState(false);

  const showDetail = () => {
    setVisible(true);
    fetchLedgerMeta({
      clusterName: commonProps.clusterName,
      ledgerId: detail.ledgerId,
    });
  };

  return (
    <>
      <Link theme='primary' onClick={showDetail}>
        {detail.ledgerId}
      </Link>
      <Dialog
        visible={visible}
        footer={null}
        width={1000}
        placement='center'
        header={<ModalHeader tags={[String(detail.ledgerId)]}>Medadata</ModalHeader>}
        onClose={() => setVisible(false)}
      >
        <Loading loading={loading}>
          <Descriptions title='基本信息' bordered>
            <Descriptions.Item
              label='EnsembleSize'
              tip='bookie可用节点最小数,集群中bookie节点一般需要大于EnsembleSize'
              value={meta.ensembleSize}
            />
            <Descriptions.Item
              label='状态'
              tip='CLOSED代表该ledger已关闭，不可再修改。OPEN代表当前正在写入的ledger'
              value={meta.state}
            />
            <Descriptions.Item
              label='WriteQuorumSize'
              tip='实际写入副本数'
              value={meta.writeQuorumSize}
            />
            <Descriptions.Item label='FormatVersion' value={meta.metadataFormatVersion} />
            <Descriptions.Item
              label='AckQuorumSize'
              tip='客户端等待副本确认数'
              value={meta.ackQuorumSize}
            />
            <Descriptions.Item label='LastEntryId' tip='最后一条数据ID' value={meta.lastEntryId} />
            <Descriptions.Item label='DigestType' value={meta.digestType} />
            <Descriptions.Item label='创建时间' value={meta.ctime} type='datetime' />
          </Descriptions>
          <Descriptions.Panel bordered title='存储位置' style={{ marginTop: 16 }}>
            <EnsemblesTable
              className='ensembles'
              columns={columns}
              data={Object.entries(meta.allEnsemblesMap || {}).map(([key, value]) => ({
                key: Number(key) + 1,
                value,
              }))}
            />
          </Descriptions.Panel>
          <Descriptions.Panel bordered title='CustomMetadata' style={{ marginTop: 16 }}>
            <JSONPretty data={meta.customMetadata} theme={require('react-json-pretty/dist/acai')} />
          </Descriptions.Panel>
        </Loading>
      </Dialog>
    </>
  );
}

export default connect(
  (state) => ({
    meta: state.topic.ledgerMeta,
    loading: state.topic.metaFetching,
  }),
  {
    fetchLedgerMeta,
  },
)(LedgerModal);

const EnsemblesTable = styled(Table)`
  tbody tr:last-child td {
    border-bottom: none;
  }
`;
